import { Action, createReducer, on } from '@ngrx/store';
import { IProductTypesResponse } from '../models/product-types.model';
import { fromStaticDataPreferredContactMethodsActions } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IPreferredContactMethodResponse } from '../models/preferred-contact-method.model';

export const preferredContactMethodsFeatureKey = 'preferredContactMethods';

export interface PreferredContactMethodsState {
  preferredContactMethodsResponse: IPreferredContactMethodResponse[];
  preferredContactMethodsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: PreferredContactMethodsState = {
  preferredContactMethodsFailure: undefined,
  preferredContactMethodsResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataPreferredContactMethodsActions.loadPreferredContactMethods, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromStaticDataPreferredContactMethodsActions.loadPreferredContactMethodsSuccess, (state, action) => ({
    ...state,
    preferredContactMethodsResponse: action.response
  })),

  on(fromStaticDataPreferredContactMethodsActions.loadPreferredContactMethodsFailure, (state, action) => ({
    ...state,
    preferredContactMethodsFailure: action.error
  }))
);

export const getPreferredContactMethodsResponse = (state: PreferredContactMethodsState) => state.preferredContactMethodsResponse;
export const getPreferredContactMethodsFailure = (state: PreferredContactMethodsState) => state.preferredContactMethodsFailure;
export const getPreferredContactMethodsIsLoaded = (state: PreferredContactMethodsState) => state.loaded;
